import React from 'react';
import { motion } from 'framer-motion';
import { OrbitRings } from './OrbitRings';
import { ChevronDown } from 'lucide-react';
export function Hero() {
  return <section className="relative min-h-screen flex items-center justify-center pt-20 overflow-hidden" data-id="element-104">
      <div className="absolute inset-0 z-0 flex items-center justify-center opacity-60" data-id="element-105">
        <OrbitRings data-id="element-106" />
      </div>

      <div className="relative z-10 max-w-5xl mx-auto px-6 text-center flex flex-col items-center" data-id="element-107">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 1,
        delay: 0.2
      }} data-id="element-108">
          <h1 className="text-5xl md:text-7xl lg:text-8xl font-black text-transparent bg-clip-text bg-gradient-to-b from-white via-[#e7ecff] to-[#6d28d9] drop-shadow-[0_0_30px_rgba(255,255,255,0.2)] mb-6 leading-tight" data-id="element-109">
            העתיד מתחיל <br className="hidden md:block" data-id="element-110" />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 to-violet-500 drop-shadow-[0_0_20px_rgba(6,182,212,0.5)]" data-id="element-111">
              מעבר לאטמוספירה
            </span>
          </h1>
        </motion.div>

        <motion.p initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 1,
        delay: 0.6
      }} className="text-lg md:text-2xl text-gray-300 max-w-2xl mb-10 font-light" data-id="element-112">
          טכנולוגיית חלל פורצת דרך המגדירה מחדש את גבולות האפשר. אנו בונים את
          התשתית לעידן הבין-כוכבי הבא.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.5,
        delay: 1
      }} className="flex flex-col sm:flex-row gap-4" data-id="element-113">
          <button className="px-8 py-4 rounded-full bg-white text-black font-bold text-lg hover:bg-cyan-50 transition-colors shadow-[0_0_30px_rgba(255,255,255,0.3)]" data-id="element-114">
            גלו את הטכנולוגיה
          </button>
          <button className="px-8 py-4 rounded-full bg-transparent border border-white/20 text-white font-bold text-lg hover:bg-white/5 transition-colors backdrop-blur-sm" data-id="element-115">
            צפו בשיגור האחרון
          </button>
        </motion.div>
      </div>

      <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      delay: 1.5,
      duration: 1
    }} className="absolute bottom-10 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 text-white/50" data-id="element-116">
        <span className="text-sm uppercase tracking-widest" data-id="element-117">גללו למטה</span>
        <motion.div animate={{
        y: [0, 10, 0]
      }} transition={{
        duration: 2,
        repeat: Infinity,
        ease: 'easeInOut'
      }} data-id="element-118">
          <ChevronDown className="w-6 h-6 text-cyan-400" data-id="element-119" />
        </motion.div>
      </motion.div>
    </section>;
}